import { render, staticRenderFns } from "./athub-collapse-item.vue?vue&type=template&id=240d70d6&scoped=true&"
import script from "./athub-collapse-item.vue?vue&type=script&lang=js&"
export * from "./athub-collapse-item.vue?vue&type=script&lang=js&"
import style0 from "./athub-collapse-item.vue?vue&type=style&index=0&id=240d70d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240d70d6",
  null
  
)

export default component.exports